import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { COMPANY } from "../data/site";

export const Footer = () => {
    return (
        <footer className="bg-foreground text-background" data-testid="footer">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-1">
                    <img src="/assets/logo/yatto-logo.jpg" alt="YATTO LLC" className="w-40 mb-4 border border-secondary/30" />
                    <p className="text-sm text-background/60 leading-relaxed">
                        Premium import, export & wholesale distribution of food, beverages and international grocery products.
                    </p>
                </div>

                <div>
                    <h4 className="font-heading font-bold text-sm uppercase tracking-[0.15em] mb-5 text-secondary">Company</h4>
                    <ul className="space-y-3 text-sm text-background/70">
                        <li><Link to="/about" className="hover:text-secondary transition-colors">About Us</Link></li>
                        <li><Link to="/catalog" className="hover:text-secondary transition-colors">Products</Link></li>
                        <li><Link to="/brands" className="hover:text-secondary transition-colors">Brands</Link></li>
                        <li><Link to="/order" className="hover:text-secondary transition-colors">Order Request</Link></li>
                        <li><Link to="/contact" className="hover:text-secondary transition-colors">Contact</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-heading font-bold text-sm uppercase tracking-[0.15em] mb-5 text-secondary">Contact</h4>
                    <ul className="space-y-3 text-sm text-background/70">
                        <li className="flex items-center gap-2"><Mail size={15} /> {COMPANY.email}</li>
                        {COMPANY.phones.map((p) => (
                            <li key={p} className="flex items-center gap-2"><Phone size={15} /> {p}</li>
                        ))}
                    </ul>
                </div>

                <div>
                    <h4 className="font-heading font-bold text-sm uppercase tracking-[0.15em] mb-5 text-secondary">Distribution</h4>
                    <p className="text-sm text-background/70 flex items-start gap-2">
                        <MapPin size={16} className="mt-0.5 shrink-0" /> {COMPANY.serviceArea}
                    </p>
                    <Link to="/order" className="inline-block mt-6 bg-secondary text-secondary-foreground px-6 py-3 text-sm font-semibold hover:bg-background hover:text-foreground transition-colors">
                        Place Order Request
                    </Link>
                </div>
            </div>
            <div className="border-t border-background/10">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background/50">
                    <span>© {new Date().getFullYear()} YATTO LLC. All rights reserved.</span>
                    <span>Wholesale Food & Beverage Distributor · {COMPANY.tagline}</span>
                </div>
            </div>
        </footer>
    );
};
